import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { cardsService } from "./cardsService";

export const suspendCard = async (
  cardId: string
): Promise<cardApiSpec.Card> => {
  const { data } = await cardsService.post(`/${cardId}/suspend`);

  return data;
};
